var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#F23F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.777 11.705.177-.177-.177-.177-1.128-1.128-.177-.177-.177.177L16 14.518l-4.295-4.295-.177-.177-.177.177-1.128 1.128-.177.177.177.177L14.518 16l-4.295 4.295-.177.177.177.177 1.128 1.128.177.176.177-.176L16 17.48l4.295 4.296.177.176.177-.176 1.128-1.128.177-.177-.177-.177L17.482 16l4.295-4.295Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
};

export default SvgClose;